export const markAsSeen = (education, educationCode) => education | educationCode;
export const markAsUnseen = (education, educationCode) => ~educationCode & education;
export const hasSeen = (education, educationCode) => educationCode === (education & educationCode);
